import classnames from "classnames/bind";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";

import { useIsArcade } from "@/hooks/useIsArcade";

import { RetailerPageProps } from "@/interfaces/retailer-page-interface";

import styles from "./retailer-pages-list.module.scss";

const cx = classnames.bind(styles);

type Props = {
    groupedStores: Array<Array<RetailerPageProps>>;
};

export const RetailerPagesList: React.FC<Props> = (props) => {
    const { groupedStores } = props;
    const { t } = useTranslation();
    const isArcade = useIsArcade();

    const retailerPagesListClassName = cx({
        [styles.retailerPagesList]: true,
        [styles.retailerPagesListArcade]: isArcade,
    });

    return (
        <div className={styles.retailerPagesListContainer}>
            {isArcade ? (
                <h4 className={styles.retailerPagesListTitleArcade}>
                    {t("retailerPages.retailerPagesList.pageListTitle")}
                </h4>
            ) : (
                <h1 className={styles.retailerPagesListTitle}>
                    {t("retailerPages.retailerPagesList.pageListTitle")}
                </h1>
            )}
            {groupedStores.map((stores, groupIndex) => (
                <ul key={groupIndex} className={retailerPagesListClassName}>
                    {stores.map((store) => (
                        <li key={store.id}>
                            <Link prefetch={false} href={store.slug}>
                                {store.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            ))}
        </div>
    );
};
